import { useEffect } from "react";


const ForgotPasswordModal = () => {

    
  useEffect(() => {
    const script = document.createElement('script');
    script.src='https://js.hsforms.net/forms/embed/v2.js';
    script.setAttribute('type', 'text/javascript');
    document.body.appendChild(script);

    script.addEventListener('load', () => {
        // @ts-ignore
        if (window.hbspt) {
            // @ts-ignore
            window.hbspt.forms.create({
                region: "na1",
                portalId: "23399414",
                formId: "4d453bfe-35b4-4699-831b-7ee4342d775a",
                target: "#hubspotFormPwd"
            })
        }
    });
}, []);

  return (
    <div className='modal fade' id='forgot-password-modal' aria-hidden='true'>
      <div className='modal-dialog modal-dialog-centered mw-900px'>
        <div className='modal-content bg-white px-5'>
          <div className='modal-header'>
            <h4 className='fw-semibold text-primary'>Forgot Password</h4>
            <button type="button" className="close border-0 bg-white" data-dismiss="modal" aria-label="Close" data-bs-dismiss="modal" title="close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div className='modal-body scroll-y'>
            <div id="hubspotFormPwd"></div>
          </div>
        </div>
      </div>
    </div>
  )
}

export {ForgotPasswordModal}